// SY12 콤보 저장·삭제 — 2.0 POST /api/v1/system/combos(새 행) · PUT /api/v1/system/combos/{id}(기존 행, 4칸 모두 수정) · DELETE /{id} (LOGISPRD-17281).
// 같은 콤보코드·옵션코드 중복을 BE 가 막지 않는다(1.0 동일). 생성자·수정자·일시는 BE 가 채워 보내지 않는다.
// 행별로 순서대로 반영하고, 실패하면 그 자리에서 멈춰 앞서 반영된 건수를 오류의 done 에 싣는다(공통코드·메뉴관리와 같은 규약).
import { useMutation, type UseMutationResult } from '@tanstack/react-query'
import request from '@/utils/request'
import { inOrder } from '@/utils/inOrder'
import { COMBOS_PATH, type ComboRow } from './useGetComboList'

interface ComboSaveBody {
  comboCode: string
  comboName: string
  optionCode: string
  optionName: string
}

export type ComboSaveRow = Pick<ComboRow, 'COMBO_CD' | 'COMBO_NM' | 'COMBO_OPT_CD' | 'COMBO_OPT_NM'> & { _id?: number }

export const useSaveCombos = (): UseMutationResult<number, Error, ComboSaveRow[]> =>
  useMutation({
    mutationFn: (rows: ComboSaveRow[]) =>
      inOrder(rows, (row) => {
        // 앞뒤 공백은 잘라 보낸다 — 1.0 SY05 저장(ComboSerializer, DRF CharField 기본 trim_whitespace)도 잘라 저장했다. 검증도 자른 값 기준이다.
        const body: ComboSaveBody = {
          comboCode: row.COMBO_CD.trim(),
          comboName: row.COMBO_NM.trim(),
          optionCode: row.COMBO_OPT_CD.trim(),
          optionName: row.COMBO_OPT_NM.trim(),
        }
        return row._id == null
          ? request.post<ApiResponseV2<unknown>, ComboSaveBody>(COMBOS_PATH, body)
          : request.put<ApiResponseV2<unknown>, ComboSaveBody>(`${COMBOS_PATH}/${row._id}`, body)
      }),
  })

export const useDeleteCombos = (): UseMutationResult<number, Error, number[]> =>
  useMutation({
    mutationFn: (ids: number[]) => inOrder(ids, (id) => request.delete<ApiResponseV2<unknown>>(COMBOS_PATH, id)),
  })
